import React from 'react'

import PtcFareFilter from '@/components/srp/Filters/PtcFareFilter'
import { filterTypes } from '@/constants/Srp'
import { FilterData, PossibleFilterTypes, PtcFareFilterType } from '@/types/srp'
import { ProcessedData } from '@/utils/srp/types'

import FilterCategory, { FilterLegs, RevampRtDivider } from '../FilterCategory'

interface PtcFareFilterContainerProps {
  onFilterChange: (
    type: PossibleFilterTypes,
    selectedValues: PtcFareFilterType,
    index: number,
    legKey: 'onwardLeg' | 'returnLeg'
  ) => void
  onwardPtcFare: PtcFareFilterType
  returnPtcFare: PtcFareFilterType
  isRT: boolean
  processedData: ProcessedData
  clearFiltersCategoryWise: (filterData: FilterData, isRT: boolean, filterType: string) => void
  selectedFilters: FilterData
  isRevamp?: boolean
}

const PtcFareFilterContainer = ({
  onFilterChange,
  onwardPtcFare,
  returnPtcFare,
  isRT,
  processedData,
  clearFiltersCategoryWise,
  selectedFilters,
  isRevamp = false,
}: PtcFareFilterContainerProps) => {
  const onClear = () => clearFiltersCategoryWise(selectedFilters, isRT, filterTypes.PTC_FARE)
  const showBothLegs = isRT && !!returnPtcFare?.enabled
  const count = Number(!!onwardPtcFare?.checked) + Number(!!returnPtcFare?.checked)
  const shared = { isRevamp, isRT, onFilterChange }

  return (
    <FilterCategory count={count} isRevamp={isRevamp} title='Special fares' onClear={onClear}>
      <FilterLegs isRevamp={isRevamp}>
        {onwardPtcFare?.enabled && (
          <PtcFareFilter
            {...shared}
            from={processedData?.source}
            legIsOnward
            ptcFare={onwardPtcFare}
            to={processedData?.destination}
          />
        )}

        <RevampRtDivider show={!!isRevamp && showBothLegs} />

        {showBothLegs && (
          <PtcFareFilter
            {...shared}
            from={processedData?.destination}
            legIsOnward={false}
            ptcFare={returnPtcFare}
            to={processedData?.source}
          />
        )}
      </FilterLegs>
    </FilterCategory>
  )
}

export default PtcFareFilterContainer
